import AppleIcon from "@mui/icons-material/Apple";
import YoutubeIcon from "@mui/icons-material/YouTube";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ContactlessIcon from "@mui/icons-material/Contactless";
import AmazonIcon from "@mui/icons-material/LibraryMusic";
import { FooterListButton } from "../../components/UIComponents/Buttons";
import { FooterListTitle } from "../../components/UIComponents/Typography";
import useMediaQuery from "../../hooks/useMediaQuery";

export default function FooterPodcastList() {
  const isDesktop = useMediaQuery("(min-width: 960px)");
  return (
    <ul className="prose dark:prose-invert max-w-none prose-reset-list prose-hr:m-0 prose-link prose-a:font-normal w-full lg:w-64 m-0 p-0">
      <div className={isDesktop ? "" : "hidden"}>
        <FooterListTitle>Podcast</FooterListTitle>
      </div>
      <FooterListButton href="https://music.amazon.com/podcasts/98e3c7b4-ffcf-48f1-af75-406e72a903c7/the-forgotten-adoption-option-podcast">
        <AmazonIcon />
        Amazon Music
      </FooterListButton>
      <FooterListButton href="https://podcasts.apple.com/us/podcast/the-forgotten-adoption-option-podcast/id1542072701">
        <AppleIcon />
        Apple
      </FooterListButton>
      <FooterListButton href="https://www.iheart.com/podcast/269-the-forgotten-adoption-opt-263713689/">
        <FavoriteIcon />
        iHeart
      </FooterListButton>
      <FooterListButton href="https://open.spotify.com/show/0ugiSikvsI4oOxzALI9FZv">
        <ContactlessIcon />
        Spotify
      </FooterListButton>
      <FooterListButton href="https://www.youtube.com/playlist?list=PLBOCuHmPaUKvd8DWs2f3MBK8ziTXFZujG">
        <YoutubeIcon />
        YouTube
      </FooterListButton>
    </ul>
  );
}
